import React from "react";
import PT from "prop-types";
import SettingsIcon from "_c/icon/Settings";
import { ControlsWrap } from "./index-styled";
import { CircleButton } from "_c/button";
import { SEARCH_NS as ns } from "@/i18n/ns";

const SearchControls = (props) => {
  return (
    <ControlsWrap>
      <CircleButton
        title={props.t(
          `${ns}:filters.${props.isFiltersOpen ? "close" : "open"}`
        )}
        aria-controls="search-filters"
        aria-expanded={props.isFiltersOpen}
        large
        greenish
        onClick={() => props.toggleFilters()}
      >
        <SettingsIcon color="white" width="18" />
      </CircleButton>
    </ControlsWrap>
  );
};
SearchControls.propTypes = {
  isMapOpen: PT.bool,
  isFiltersOpen: PT.bool,

  toggleMap: PT.func,
  toggleFilters: PT.func,
};

export default SearchControls;
